var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAreYouSure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 104,
    viewBox: "0 0 106 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6602 51.9999C11.6602 75.9321 30.6433 95.3333 54.0602 95.3333C77.4768 95.3333 96.4602 75.9321 96.4602 51.9999C96.4602 28.0675 77.4768 8.6665 54.0602 8.6665",
    stroke: "#EB5757",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8902 22.0079C23.4768 21.3724 24.0813 20.7544 24.7029 20.1547M36.877 11.8273C37.6466 11.4738 38.4279 11.1421 39.2203 10.8333M14.7628 34.4149C14.4131 35.2091 14.0853 36.0155 13.7803 36.8333",
    stroke: "#EB5757",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7798 39L54.0598 52M54.0598 52L41.3398 65M54.0598 52L66.7798 65M54.0598 52L41.3398 39",
    stroke: "#EB5757",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreYouSure);
export default __webpack_public_path__ + "static/media/are-you-sure.4539d53e6eae46600cc8e94b3504426f.svg";
export { ForwardRef as ReactComponent };